
export const environment = {
  production: true,
  backendUrl: 'http://192.168.24.244:3339/api/',
  portalUrl: 'https://portalunico-qa.neuquen.edu.ar/',
};
